module.exports = __webpack_public_path__ + "static/media/flag-green.a84e5eb3.gif";